import React, { Component } from 'react'
import { user_agreement_data } from './user_agreement_data'
import './agreement.scss'

export default class user_agreement extends Component {
    render() {
        return (
            <div className="agreement-container">
                <div dangerouslySetInnerHTML={{ __html: user_agreement_data }}></div>
            </div>
        )
    }
}
